import { getModule } from 'vuex-module-decorators';

import { StoreSingleton } from '.';
import PeopleStore from './people.module';

export const peopleStore = getModule<PeopleStore>(PeopleStore, StoreSingleton.getInstance());
